// App.jsx (UPDATED: 🇨🇦 flag next to logo in Header – prominent on all pages. Footer bonus flag.)
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Services from './pages/Services';
import Contact from './pages/Contact';
import { useState } from 'react';

 function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

return (
    <>
      <header className="bg-white/95 backdrop-blur-md shadow-sm sticky top-0 z-50 border-b border-emerald-100/50 transition-all duration-200">
        <nav className="max-w-6xl mx-auto px-4 sm:px-6 py-3.5 lg:py-5 flex justify-between items-center">
          
          {/* ENHANCED LOGO - Bigger subtitle, gradient text, visible on all sizes */}
          <Link 
            to="/" 
            className="flex items-center gap-2 sm:gap-3 group min-w-0 flex-1 hover:no-underline focus:no-underline"
            onClick={() => setIsMenuOpen(false)}
          >
            <span className="text-2xl sm:text-3xl lg:text-4xl drop-shadow-sm group-hover:scale-110 transition-transform duration-200 flex-shrink-0">
              🇨🇦
            </span>
            <div className="flex flex-col leading-tight min-w-0 flex-1 -space-y-0.5">
              <span className="text-lg sm:text-xl lg:text-2xl font-black text-emerald-900 tracking-tightest truncate bg-gradient-to-r from-emerald-900 to-emerald-700 bg-clip-text text-transparent">
                Our Financial Success
              </span>
              {/* UPGRADED SUBTITLE: Always visible, gradient, bolder */}
              <span className="text-xs sm:text-sm lg:text-base font-black tracking-widest uppercase bg-gradient-to-r from-emerald-600 via-emerald-500 to-amber-500 bg-clip-text text-transparent drop-shadow-sm">
                Family Wealth & Harmony
              </span>
            </div>
          </Link>

          {/* DESKTOP NAV - Faster transitions */}
          <ul className="hidden md:flex items-center gap-1 sm:gap-2 lg:gap-8">
            <li>
              <Link 
                to="/" 
                className="text-gray-700 font-semibold hover:text-emerald-800 hover:bg-emerald-50 px-3 py-2 rounded-xl transition-all duration-200 text-sm lg:text-base border border-transparent hover:border-emerald-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
            </li>
            <li>
              <Link 
                to="/services" 
                className="text-gray-700 font-semibold hover:text-emerald-800 hover:bg-emerald-50 px-3 py-2 rounded-xl transition-all duration-200 text-sm lg:text-base border border-transparent hover:border-emerald-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Services
              </Link>
            </li>
            <li>
              <Link 
                to="/contact" 
                className="bg-gradient-to-r from-emerald-600 to-emerald-700 hover:from-emerald-700 hover:to-emerald-800 text-white font-black px-6 py-2.5 lg:px-8 lg:py-3 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-200 text-sm lg:text-base tracking-wide whitespace-nowrap ml-2 active:scale-95"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact Us
              </Link>
            </li>
          </ul>

          {/* MOBILE HAMBURGER - Snappier */}
          <button
            className="md:hidden p-1.5 -mr-1 rounded-xl text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 transition-all duration-150 active:scale-95"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2.5} 
                d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} 
              />
            </svg>
          </button>
        </nav>

        {/* MOBILE MENU - Faster slide, better fonts */}
        {isMenuOpen && (
          <div className="md:hidden bg-white/98 backdrop-blur-md border-t border-emerald-100 shadow-2xl origin-top transition-all duration-200 ease-out">
            <ul className="px-4 sm:px-6 py-6 space-y-2">
              <li>
                <Link 
                  to="/" 
                  className="block w-full text-left px-5 py-4 text-xl font-black text-gray-800 hover:text-emerald-800 hover:bg-gradient-to-r hover:from-emerald-50 hover:to-emerald-100 rounded-2xl shadow-sm hover:shadow-md transition-all duration-150 border border-emerald-100 hover:border-emerald-300 active:scale-[0.98]"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/services" 
                  className="block w-full text-left px-5 py-4 text-xl font-black text-gray-800 hover:text-emerald-800 hover:bg-gradient-to-r hover:from-emerald-50 hover:to-emerald-100 rounded-2xl shadow-sm hover:shadow-md transition-all duration-150 border border-emerald-100 hover:border-emerald-300 active:scale-[0.98]"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="block w-full text-center bg-gradient-to-r from-emerald-600 to-emerald-700 hover:from-emerald-700 hover:to-emerald-800 text-white font-black px-8 py-5 rounded-3xl shadow-2xl hover:shadow-3xl active:scale-[0.97] transition-all duration-200 text-xl tracking-wide mx-auto max-w-max"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        )}
      </header>
    </>
  );
}

function Footer() {
  return (
    <footer className="bg-emerald-800 text-white py-12">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <p className="text-lg mb-4 font-semibold text-amber-300">
          Government-licensed 🇨🇦 to serve families across Canada. {/* NEW: Flag accent */}
        </p>
        <p className="text-sm opacity-90">&copy; 2026 Our Financial Success. Building community & wealth harmony.</p>
      </div>
    </footer>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}
